import React from "react";
import { motion } from "framer-motion";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.05 } },
};

const item = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

// Shared, animated hero eyebrow + heading treatment used across the marketing
// pages (Products, Solutions, About, Blogs, Contact) so their intros read as
// one consistent, elevated design instead of plain stacked text.
export default function HeroIntro({ eyebrow, heading, headingClassName = "", children }) {
  return (
    <motion.div variants={container} initial="hidden" animate="show">
      <motion.p
        variants={item}
        className="flex items-center gap-2.5 text-sm font-bold uppercase tracking-[0.2em] text-primary"
      >
        <span className="h-px w-6 bg-primary/50" aria-hidden="true" />
        {eyebrow}
      </motion.p>
      <motion.h1
        variants={item}
        className={`mt-4 font-serif-display text-4xl font-medium leading-tight tracking-tight text-neutral-900 sm:text-5xl md:text-6xl ${headingClassName}`}
      >
        {heading}
      </motion.h1>
      <motion.div variants={item}>{children}</motion.div>
    </motion.div>
  );
}
